import React,  { useRef } from "react";
import headerImage from "../../assets/header4.jpg";
import w9_1 from '../../assets/w9_1.jpg';
import w9_2 from '../../assets/w9_2.jpg';
import w9_3 from '../../assets/w9_3.jpg';
import w9_4 from '../../assets/w9_4.jpg';
import w9_5 from '../../assets/w9_5.jpg';
import w9_6 from '../../assets/w9_6.jpg';
import w9_9 from '../../assets/w9_9.jpg';
import w9_11 from '../../assets/w9_11.jpg';
import w9_12 from '../../assets/w9_12.jpg';
import w9_13 from '../../assets/w9_13.jpg';
import w9_14 from '../../assets/w9_14.jpg';
import w9_15 from '../../assets/w9_15.jpg';
import w9_16 from '../../assets/w9_16.jpg';
import MediaGallery from "../../components/MediaGalleryW9";



const Assignment10 = () => {
  const DevBoard = useRef(null);
  const sensor = useRef(null);
  const programming = useRef(null);
  const measuring = useRef(null);

  const scrollToSection = (ref) => {
    ref.current?.scrollIntoView({ behavior: "smooth" });
  };


    
  return (

    <div className="container mx-auto my-8 px-5 max-w-3xl bg-gray-100 p-8 rounded-lg shadow-md">
      {/* Header */}
      <div className="relative mb-8">
        <img
          src={headerImage}
          alt="Header"
          className="w-full h-64 object-cover rounded-lg shadow-md  object-cover filter grayscale brightness-75"
        />
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black to-transparent p-4 rounded-b-lg">
          <h1 className="text-4xl font-bold text-bg-secondary"  style={{ textShadow: '2px 2px 4px rgba(0, 0, 0, 1)' }}>9. Week - Input Devices </h1>
          <p className="text-gray-300 mt-2">Published on: <span className="font-semibold">March 25, 2025</span></p>
          <div className="mt-4 flex space-x-4">
         {/* Navigation Links */}
      <div className="mt-4 flex space-x-4">
        <button onClick={() => scrollToSection(DevBoard)} className="text-white bg-secondary px-3 py-1 rounded hover:bg-secondary">
         Development Board
        </button>
        <button onClick={() => scrollToSection(sensor)} className="text-white bg-secondary px-3 py-1 rounded hover:bg-secondary">
          Ultrasonic Sensor
        </button>
        <button onClick={() => scrollToSection(programming)} className="text-white bg-secondary px-3 py-1 rounded hover:bg-secondary">
          Programming
        </button>
        <button onClick={() => scrollToSection(measuring)} className="text-white bg-secondary px-3 py-1 rounded hover:bg-secondary">
          Measuring
        </button>
        </div>
        </div>
        </div>
        </div>
        <p className="text-justify text-gray-700 mb-6"> In this week's assignment, we were asked to explore input devices by connecting a sensor to a microcontroller and reading data from it. The goal was to understand how different types of sensors can interact with a board we designed or used earlier in the course. For this assignment, I decided to connect an HC-SR04 ultrasonic distance sensor to my ESP32S3 Plus board. I successfully wired the sensor, programmed it, and was able to receive and interpret distance measurements. In the following sections, I will explain how I redesigned my board, how I connected the sensor, and how I read and displayed the data. </p>


        {/* Redesign Section*/}
        <div ref={DevBoard}></div>
        <h2 className="text-3xl font-bold text-left mb-6">Redesign of the DevBoard</h2>
        <p className="text-justify text-gray-700 mb-6">
        Since I will need a board in my final assignment that can read values from two ultrasonic sensors and transmit them via I2C to another board, I decided to design a new board for this week's task. This board should fulfill that purpose and serve as a prototype for the final project board.
      </p>
      <p className="text-justify text-gray-700 mb-6">
      I used my KiCad project from week 8 as a basis to create an optimized version of the board for the ultrasonic sensors with two pinheaders for VCC, ECHO, TRIG and GND each. Additionally, I added a dedicated pin header for the I2C interface to make communication with other devices easier.
      </p>
      <img src={w9_1} alt="" className="my-4 mx-auto rounded shadow-md" />

      <p className="text-justify text-gray-700 mb-6">
      Since I reorganized the connections on the PCB, I also had to adjust the routing in the PCB editor accordingly.
      </p>
      <img src={w9_2} alt="" className="my-4 mx-auto rounded shadow-md" />
      <img src={w9_3} alt="" className="my-4 mx-auto rounded shadow-md" />


      <p className="text-justify text-gray-700 mb-6">
This time, we included a <strong>rubout underneath the microcontroller</strong> area on the PCB. This was done to avoid potential issues during the soldering process, such as accidental short circuits or poor adhesion caused by uneven copper underneath the chip. Removing the copper beneath the microcontroller helps ensure a smoother and more reliable assembly.
</p>

      <img src={w9_4} alt="" className="my-4 mx-auto rounded shadow-md" />
      <p className="text-justify text-gray-700 mb-6">
      During the fabrication of the PCB, I encountered some issues: several milling bits were worn out and had to be replaced. Additionally, I learned from other students that some boards were misaligned in the LPKF milling machine. To resolve this, the sacrificial layer had to be replaced, and the affected milling bits were swapped out
      </p>
      <p className="text-justify text-gray-700 mb-6">
      After maintaining the machine—which also included another spindle maintenance—I was able to mill my board without major issues. Since I wanted to protect the board from oxidation, I applied solder lacquer before assembling the components.
      </p>
      <img src={w9_5} alt="" className="my-4 mx-auto rounded shadow-md" />
      <img src={w9_6} alt="" className="my-4 mx-auto rounded shadow-md" />

      <p className="text-justify text-gray-700 mb-4 italic">
All components used in this week's assignment: my custom ESP32S3-based development board, two HC-SR04 ultrasonic sensors, pin headers, jumper wires and SMD components.
</p>



      <p className="text-justify text-gray-700 mb-6">
      Soldering the board went without major issues along the way. The only thing that slightly annoyed me was a drop of solder that fell right onto the GND side of the LED, leaving behind a visible stain. Luckily, it landed on the ground plane, so the damage was purely aesthetic.</p>

<MediaGallery></MediaGallery>





        {/* Sensor Section*/}
        <div ref={sensor}></div>
        <h2 className="text-3xl font-bold text-left mb-6">Ultrasonic Sensor</h2>

<p class="text-justify text-gray-700 mb-6">
  The <strong>HC-SR04</strong> is a popular low-cost ultrasonic sensor that uses sound waves to measure distance. It's widely used in robotics, automation, and DIY electronics for obstacle avoidance and range detection.
</p>

<h2 className="text-xl font-bold text-left mb-2">Working Principle</h2>
<p class="text-justify text-gray-700 mb-6">
  The HC-SR04 works using the <strong>time-of-flight method</strong>. It sends an ultrasonic pulse and waits for the echo to return. The time taken for the round trip is used to calculate distance.
</p>
<ul class="list-disc pl-6 text-gray-700 mb-6">
  <li>Send a 10μs HIGH pulse to the <strong>Trig</strong> pin.</li>
  <li>The sensor emits 8 ultrasonic pulses at 40kHz.</li>
  <li>The <strong>Echo</strong> pin goes HIGH until the echo returns.</li>
  <li>Measure the duration of the HIGH state to calculate the distance.</li>
</ul>


<img src={w9_13} alt="" class="my-4 mx-auto rounded shadow-md max-w-sm" />
<img src={w9_14} alt="" class="my-4 mx-auto rounded shadow-md max-w-sm" />


<h2 class="text-xl font-semibold mb-2">Pinout</h2>

<ul class="list-disc pl-6 text-gray-700 mb-6">
  <li><strong>VCC:</strong> 5V power supply</li>
  <li><strong>Trig:</strong> Trigger input signal</li>
  <li><strong>Echo:</strong> Output signal (pulse width indicates distance)</li>
  <li><strong>GND:</strong> Ground</li>
</ul>

<h2 class="text-xl font-semibold mb-2">Technical Specifications</h2>
<ul class="list-disc pl-6 text-gray-700 mb-6">
  <li><strong>Operating Voltage:</strong> 3.3V – 5V DC</li>
  <li><strong>Current:</strong> 15mA typical</li>
  <li><strong>Frequency:</strong> 40kHz</li>
  <li><strong>Measuring Range:</strong> 2cm – 400cm</li>
  <li><strong>Accuracy:</strong> ±3mm</li>
  <li><strong>Measuring Angle:</strong> ~15°</li>
</ul>

<h2 class="text-xl font-semibold mb-2">Distance Calculation</h2>
<p class="text-justify text-gray-700 mb-6">
  Use the following formulas to convert the echo pulse duration into distance:
</p>
<pre class="list-disc pl-6 text-gray-700 mb-6">
distance = (duration &gt; 0) ? (duration * SOUND_SPEED / 2) : -1;

</pre>
<p class="text-justify text-gray-700 mb-6">
If the duration is greater than zero, I multiply the duration (time of flight of the signal) with the speed of the sound and divide it by 2 (as the signal needs to return to the receiver once it is reflected from the obstacle).
</p>
<h2 class="text-xl font-semibold mb-2">Applications</h2>

<ul class="list-disc pl-6 text-gray-700 mb-6">
  <li>Robotic obstacle avoidance</li>
  <li>Liquid level detection</li>
  <li>Object proximity sensing</li>
  <li>Parking assistance systems</li>
</ul>

        {/*Programming Section*/}
        <div ref={programming}></div>
        <div ref={measuring}></div>
        <h2 className="text-3xl font-bold text-left mb-6">Programming and Measuring</h2>

        <img src={w9_9} alt="" className="my-4 mx-auto rounded shadow-md" />
<p class="text-justify text-gray-700 mb-6">
  For this week, I reused the Arduino code I had written during Week 4, where I already worked with an ultrasonic sensor. I simply adapted the code to match the GPIO pin assignments of the Seeed Studio XIAO ESP32S3 on my newly designed development board. 
  Once the correct pins were set, I was able to successfully measure distances with the HC-SR04 sensor.
</p>
<img src={w9_11} alt="" className="my-4 mx-auto rounded shadow-md" />
<p class="text-justify text-gray-700 mb-6">
  While measuring with the ultrasonic sensor, I noticed that it requires a <strong>5V power supply</strong> to operate correctly. Unfortunately, my board was originally designed for 3.3V, which caused some issues. Luckily, I had also added a pin header with 5V supply to the board, so I was still able to connect the sensor and get valid measurements without having to redesign the entire board for now.
</p>
<img src={w9_12} alt="" className="my-4 mx-auto rounded shadow-md" />
<p className="text-justify text-gray-700 mb-6">
        I did verify the sensor’s accuracy with a ruler – but unfortunately, I wasn’t born with three hands, so I couldn’t hold the object, the ruler, and the camera all at once for a picture. 
      </p>
<div class="bg-yellow-100 border-l-4 border-yellow-500 text-yellow-700 p-4 my-6 rounded-md shadow-sm">
  <h4 class="font-bold text-lg mb-2">⚠️ Lessons Learned</h4>
  <p class="text-justify text-gray-800">
    This week I learned how important it is to <strong>design and test a prototype with sufficient time in advance</strong>. While working with the ultrasonic sensor, I realized that it requires a 5V power supply — something I hadn’t fully considered in my board design, which was optimized for 3.3V. 
  </p>
  <p class="text-justify text-gray-800 mt-2">
    Luckily, I had included a <strong>5V pin header</strong> on the board just in case, which allowed me to still perform measurements successfully. This situation clearly showed me the importance of <strong>carefully checking datasheets</strong> and electrical requirements again before finalizing any hardware.
  </p>
</div>
<h2 className="text-xl font-bold text-left mb-6">Outlook & Improvements for the Next Version</h2>
<p class="text-justify text-gray-800 mt-2">
Since I’ll need two ultrasonic sensors for collision avoidance in my robot, I plan to route the 5V connection directly to the pin headers for the sensors in the next version of the board. Additionally, I’m currently researching which connector and cable types would work best to ensure secure and reliable connections between the various sensors and boards inside the robot.
</p>

<h2 className="text-xl font-bold text-left mb-4 mt-4">Workaround for testing both sensors</h2>
<p className="text-justify text-gray-700 mb-6"> Since I only had one dedicated 5V output on my board and needed to power two ultrasonic sensors, I had to find a workaround. Unfortunately, I didn't have a Y-splitter cable at hand. As an alternative, I used a multimeter probe with a banana-to-pin connector to temporarily connect both sensors to the 5V pin. This allowed me to provide sufficient power to both sensors at the same time. </p>
<img src={w9_15} alt="" className="my-4 mx-auto rounded shadow-md" />   
<p className="text-justify text-gray-700 mb-6"> This improvised solution worked well for testing purposes, and I was able to successfully read and display the distance measurements from both ultrasonic sensors in the Serial Monitor. However, for the final version of my board, I will add a second dedicated 5V connection to ensure stable and permanent wiring for both sensors. </p>
<img src={w9_16} alt="" className="my-4 mx-auto rounded shadow-md" />   
        
        {/* Group Assignment*/}
        <div ref={measuring}></div>
        <h2 className="text-3xl font-bold text-left mb-4 mt-2">Group Assignment</h2>
        <p className="text-justify text-gray-700 mb-4">
        As always you will find our group assignment on our
        <a 
          href="https://fabacademy.org/2025/labs/bottrop/Assignments/week09/" 
          className="text-blue-500 underline ml-1" 
          target="_blank" 
          rel="noopener noreferrer"
        >
          group documentation page
        </a>.
      </p>


      <h2 className="text-3xl font-bold text-left mb-6 mt-2">Downloads</h2>       
      <a
    style={{ display: "block" }}
    href="https://fabacademy.org/2025/labs/bottrop/students/annasophia-brokuf/files/Ultrasonic_Input_Week.ino"
    download
  >
    📎 Download Sketch
  </a>
  <a
    style={{ display: "block" }}
    href="https://fabacademy.org/2025/labs/bottrop/students/annasophia-brokuf/files/ESP32_Ultrasonic_Input_Week_KiCadFiles.zip"
    download
  >
    📎 Download KiCad Files (ZIP)
  </a>
  <a
    style={{ display: "block" }}
    href="https://fabacademy.org/2025/labs/bottrop/students/annasophia-brokuf/files/ESP32_Ultrasonic_Input_Week_GerberFiles.zip"
    download
  >
    📎 Download Gerber Files (ZIP)
  </a>
        </div>



  );
};

export default Assignment10;
